<template>
  <div class="menu-item">
    <router-link
      class="menu-link"
      exact-active-class="active"
      :to="menuItem.route"
    >
      <span class="menu-icon">
        <span class="svg-icon">
          <inline-svg class="inline-svg" :src="menuItem.svgIcon" />
        </span>
      </span>
      <span class="menu-title">{{ menuItem.heading }}</span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "menu-item",
  props: {
    menuItem: {
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-title {
  color: #fff !important;
  font-family: "Poppins";
  font-weight: 500;
  font-size: 12px;
  text-transform: uppercase;
}
.inline-svg {
  width: 20px;
  fill: #fff;
}
.menu-link.active {
  .menu-title {
    color: #2d75b5 !important;
  }
  .inline-svg {
    fill: #2d75b5;
  }
}
</style>
